const accordions = document.querySelectorAll(".accordion");

accordions.forEach((accordion, index) => {
    accordion.addEventListener("click", function () {
        const panel = this.nextElementSibling;
        this.classList.toggle("active");

        if (this.classList.contains("active")) {
            panel.style.maxHeight = panel.scrollHeight + "px";
        } else {
            panel.style.maxHeight = null;
        }

        accordions.forEach((acc) => {
            if (acc !== this) {
                acc.classList.remove("active");
                acc.nextElementSibling.style.maxHeight = null;
            }
        });
    });
});